import { render } from "./ButtonLarge.vue?vue&type=template&id=0db6698e&scoped=true"
import script from "./ButtonLarge.vue?vue&type=script&lang=js"
export * from "./ButtonLarge.vue?vue&type=script&lang=js"

import "./ButtonLarge.vue?vue&type=style&index=0&id=0db6698e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db6698e"]])

export default __exports__